import { RouteConfig } from 'vue-router';

export default [{
  path: 'list',
  name: 'imageList',
  component: () => import('../containers/list.vue')
}] as RouteConfig[];
